import { httpClient } from '../httpClient';

export const complianceApi = {
  getAll: () =>
    httpClient.get('/compliance-engine/all'),

  getPolicies: (params) =>
    httpClient.get('/compliance-engine/policies', { params }),

  createPolicy: (data) =>
    httpClient.post('/compliance-engine/policies', data),

  getPolicyById: (id) =>
    httpClient.get(`/compliance-engine/policies/${id}`),

  updatePolicy: (id, data) =>
    httpClient.put(`/compliance-engine/policies/${id}`, data),

  deletePolicy: (id) =>
    httpClient.delete(`/compliance-engine/policies/${id}`),

  testPolicy: (id) =>
    httpClient.post(`/compliance-engine/policies/${id}/test`),

  getTestResults: (params) =>
    httpClient.get('/compliance-engine/test-results', { params }),

  getTestResultById: (id) =>
    httpClient.get(`/compliance-engine/test-results/${id}`),

  getStats: () =>
    httpClient.get('/compliance-engine/stats'),

  getTemplates: () =>
    httpClient.get('/compliance-engine/templates'),

  export: (data, options) =>
    httpClient.post('/compliance-engine/export', data, options),

  // Spec 031 US4 (T050, FR-022a) — posture contributor weight config.
  getPostureWeights: () =>
    httpClient.get('/compliance/posture/weights'),

  updatePostureWeights: (data) =>
    httpClient.put('/compliance/posture/weights', data),

  // Spec 031 US4 (T044/T045, FR-021/FR-022) — scored posture contributors.
  getPostureContributors: () =>
    httpClient.get('/compliance/posture/contributors'),

  // Spec 031 US4 (T053, FR-023) — compliance-routed remediation gap tasks.
  getGapTasks: (params) =>
    httpClient.get('/compliance/gap-tasks', { params }),
};
